import { Anrede, Domaenenwert, Tarifbereich } from '@ps20/bff-models';
import { Adresse } from './adresse';

export enum VnRoleEnum {
  MITARBEITER = 'mitarbeiter',
  SONSTIGE = 'sonstige',
  KEIN = 'kein',
}

export interface Versicherungsnehmer {
  vorname?: string;
  nachname?: string;
  firmenname?: string;
  juristisch?: boolean;
  businessForm?: Domaenenwert;
  anrede?: Anrede;
  geburtsdatum?: string;
  adresse?: Adresse;
  isAssekuranztarif?: boolean;
  tarifbereich?: Tarifbereich;
  currentRole: VnRoleEnum;
  selectedRole?: VnRoleEnum;
  vorbelegteRole?: VnRoleEnum;
  kundennummer?: string;
}

export function convertRoleToTarifbereich(role: VnRoleEnum): Tarifbereich {
  switch (role) {
    case VnRoleEnum.KEIN:
      return Tarifbereich.E;

    case VnRoleEnum.SONSTIGE:
      return Tarifbereich.FI;

    default:
      // Allianzmitarbeiter oder Kooperationspartner
      return Tarifbereich.A;
  }
}

export function convertTarifbereichToRole(role: Tarifbereich): VnRoleEnum {
  switch (role) {
    case Tarifbereich.E:
      return VnRoleEnum.KEIN;

    case Tarifbereich.FI:
      return VnRoleEnum.SONSTIGE;

    default:
      return VnRoleEnum.MITARBEITER;
  }
}
